var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2175_7186)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.73356 4.58774L9.17185 2.1486L9.16603 15.0134C9.16603 15.4736 9.53911 15.8467 9.99934 15.8467C10.4596 15.8467 10.8326 15.4736 10.8326 15.0134L10.8385 2.16278L13.2651 4.59024C13.5962 4.90996 14.1237 4.90082 14.4434 4.56977C14.7553 4.24685 14.7553 3.73486 14.4434 3.41194L11.7676 0.732801C10.7916 -0.243824 9.20876 -0.244332 8.23214 0.731668C8.23175 0.732059 8.23139 0.732411 8.231 0.732801L5.55522 3.40944C5.2355 3.74049 5.24464 4.26802 5.57569 4.58774C5.89861 4.89965 6.4106 4.89965 6.73356 4.58774Z",
    fill: "#DF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1663 13.3333C18.7061 13.3333 18.333 13.7063 18.333 14.1666V17.4998C18.333 17.9601 17.9599 18.3331 17.4997 18.3331H2.49992C2.03969 18.3331 1.66661 17.9601 1.66661 17.4998V14.1666C1.66661 13.7063 1.29353 13.3333 0.833307 13.3333C0.37308 13.3333 0 13.7063 0 14.1666V17.4998C0 18.8805 1.11928 19.9998 2.49996 19.9998H17.4997C18.8804 19.9998 19.9997 18.8805 19.9997 17.4998V14.1666C19.9996 13.7063 19.6265 13.3333 19.1663 13.3333Z",
    fill: "#DF0000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2175_7186"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.4dbcd36e9f3eb1eb79765b67d77b8a23.svg";
export { ForwardRef as ReactComponent };